/**
 * 获取页面路径部分
 *
 * @function getPath
 * @return {string}
 */
import { Config, ROUTE_MODE } from './config';
var getPath = function getPath() {
  if (Config.ROUTE_MODE === ROUTE_MODE.HASH) {
    return location.hash.slice(1);
  }
  return location.pathname;
};
export default getPath;